module.exports = __webpack_public_path__ + "img/1.3666d805.jpg";